import { Inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LIB_CONFIG } from '@challenger/care/lib-config';
import { FindByIpService } from '@challenger/care/services/find-by-ip.service';
import { LibConfig } from '../models/lib-config.model';

@Injectable({
  providedIn: 'root',
})
export class IpIdentificationService {
  proxyIp = null;

  constructor(
    private findByIpService: FindByIpService,
    private route: ActivatedRoute,
    @Inject(LIB_CONFIG) private config: LibConfig
  ) {
    this.route.queryParams.subscribe((param) => {
      this.proxyIp = this.config?.featureFlags?.enableIPFromURL ? param?.ipAddress : '';
    });
  }

  findByIpAddress() {
    const ip = this.proxyIp || this.getIPFromHeader();
    return this.findByIpService.findByIp(ip);
  }

  protected getIPFromHeader() {
    /*
    const location = window.document.location;
    const req = new XMLHttpRequest();
    // @ts-ignore
    req.open('HEAD', location, false);
    req.send(null);
    let ip = req.getResponseHeader('X-Virgin-IP');
    // MTD with phone number should not set dummy IP. Set #setFindByIPNull to the URL to prevent dummy IP
    const reqURL = location.href.includes('setFindByIPNull');

    if (!ip && !reqURL && this.config.envName !== 'prod') {
      ip = '10.0.0.1';
    }
    return ip;
    */
   return null;
  }
}
